module.exports = __webpack_public_path__ + "images/bef799e55c6fcecd8cde3fe6dade7dc3-profile.jpg";